<div class="outsideWrapper" [style]="outsideWrapper_style">
    <div class="insideWrapper">
      <!--  <ng-container *ngIf="!loadBackGroundAsync">
           <img #bgimg class="issue-image  coveredImage" [src]="bgimage">  
        </ng-container>  -->
        
        <canvas #canvas [attr.id]="canvas_id" [width]="width" [height]="height" class="canvas-image coveringCanvas" (contextmenu)="handleRightClick($event)">
        </canvas>
    </div>
</div> 


<!-- <canvas #canvas [attr.id]="canvas_id" [width]="width" [height]="height" class="canvas-image coveringCanvas" (contextmenu)="handleRightClick($event)">
</canvas> -->